import { Calendar, CalendarProps } from '@progress/kendo-react-dateinputs';

export const CustomCalendar = (props: CalendarProps) => <Calendar {...props} navigation={false} />;
